module.exports = __webpack_public_path__ + "static/media/bg-heart.575b9fd8.png";